import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModalWithTimer } from 'apps/auth/actions/appAction';
import { changeFormFieldValue } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import Form from 'apps/auth/components/form-multi/Form';
import { clearLeadingSpace, getSortFields } from 'apps/auth/components/form-multi/utils';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import { ADDITIONAL_INFO_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { INFO_SCREEN } from 'apps/auth/constants/Constants';
import { FINISH_REGISTRATION } from 'apps/auth/constants/formName';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';
import { useDynamicHeightButton } from 'apps/auth/hooks/useDynamicHeightButton';

import FailedUnavailableAddressModal from './FailedUnavailableAddressModal';

const formName = FINISH_REGISTRATION;

const AdditionalFieldsScreen = (props) => {
    const form = useForm(formName);
    const fields = form.fields;
    const { tellBitMoreAboutYourselfTitle, continueButton } = usePageMessages();
    const buttonPosition = useDynamicHeightButton(true);
    const { residenceAddressMustBeUpdated } = useExtra();
    const modalRef = useRef(null);

    useEffect(() => {
        amplitude.getInstance().logEvent(ADDITIONAL_INFO_SHOWN);
    }, []);

    const submitHandler = (newFields, json) => {
        if (json?.messages && json?.extra?.redirectTo) {
            const successMessage = json.messages.successScreenInfoText;
            if (successMessage) {
                props.toggleModalWithTimer(true, successMessage, () => {
                    window.location.href = json.extra.redirectTo;
                });
            }
        } else if (json?.extra?.failedUnavailableAddress) {
            modalRef.current?.open(
                <FailedUnavailableAddressModal
                    modalRef={modalRef}
                    json={json}
                    formName={formName}
                    fields={fields}
                    mainText={props.mainText}
                    topButtonCaption={props.topButtonCaption}
                    topButtonLink={props.topButtonLink}
                    changeFormFieldValue={props.changeFormFieldValue}
                />,
            );
        }
    };

    const beforeSubmit = () => clearLeadingSpace(fields, formName, props.changeFormFieldValue);

    return (
        <CommonPage
            leftCloseIcon
            isBackButton
            onClickIcon={() => {
                if (residenceAddressMustBeUpdated) {
                    window.location.href = AUTH_SEND_MAIN_LINK;
                    return;
                }
                props.setScreen(INFO_SCREEN);
            }}
        >
            <HeaderPanel title={tellBitMoreAboutYourselfTitle} />
            <Form
                formName={formName}
                onSubmitHandler={submitHandler}
                getCanonicalPath={true}
                action={form.action}
                checkNotVisibleField={false}
                beforeSubmit={beforeSubmit}
            >
                <fieldset>
                    {getSortFields(fields).map((f) => {
                        const field = fields[f.name];
                        if (field?.visible) {
                            return (
                                <fieldset key={`${formName}-fields-${field.name}`}>
                                    <InputAutoDetect field={field} formName={formName} isClearErrorOnFocus={true} />
                                </fieldset>
                            );
                        }
                    })}
                </fieldset>
                <FixedBottomPanel isRightAligned buttonPosition={buttonPosition}>
                    <Button type="submit" raised={true} caption={continueButton} />
                </FixedBottomPanel>
            </Form>
            <ModalNew ref={modalRef} />
        </CommonPage>
    );
};

export default connect(null, { toggleModalWithTimer, changeFormFieldValue })(AdditionalFieldsScreen);
